import { useEffect, useState } from 'react';
import { listEventTypes } from 'services/Calender/calendarServices';
import { totalCountEvent } from 'services/generalServices';

export default function useGetEventTypes(practiceAreaId = []) {
  const [typeList, setTypeList] = useState([]);
  const [isEventTypeLoading, setIsEventTypeLoading] = useState(false);

  const getEventTypes = (practiceAreaId = []) => {
    setIsEventTypeLoading(true);
    totalCountEvent('event-type')
      .then((response) => {
        let obj = {
          pageLimit: response.data,
          pagination_token: '',
          pagination_direction: '',
          practiceAreaId: practiceAreaId,
        };
        listEventTypes(obj)
          .then((res) => {
            let data = res?.data['event-type'];
            let tempArray = [];

            data.forEach((item) => {
              tempArray.push({
                event_type: item.event_type,
                event_type_icon: item.event_type_icon,
                event_type_id: item.event_type_id,
              });
            });

            setTypeList(tempArray);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => setIsEventTypeLoading(false));
      })
      .catch((err) => {
        console.log(err);
        setIsEventTypeLoading(false);
      });
  };

  useEffect(() => {
    getEventTypes(practiceAreaId);
  }, []);

  return {
    getEventTypes,
    typeList,
    isEventTypeLoading,
  };
}
